// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ZnSB","productName":"Table_productName__2y-Zd"};